export default {
  next: 'Weiter',
}
